// extracted by mini-css-extract-plugin
export default {"error-page":"ErrorPage_error-page__2OnBv","goBack":"ErrorPage_goBack__LaGWp"};